var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"barChartQs",class:_vm.className,style:({ height: _vm.height }),attrs:{"id":"BarChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }